import type {CSSProperties} from 'react';
import {CheckOutlined} from '@ant-design/icons';
import clsx from 'clsx';

import {ACCENT_CHOICES, type AccentChoice, type AccentOption} from '@atoms/accent';
import {useAccentChoice} from '@hooks/useAccent';

import styles from './AccentPicker.module.scss';

// Карточки accent-цветов с dot + label. Активная обведена своим цветом.
export const AccentPicker = () => {
  const [accent, setAccent] = useAccentChoice();

  return (
    <div className={styles.swatches}>
      {ACCENT_CHOICES.map((option) => (
        <Swatch
          key={option.value}
          option={option}
          active={accent === option.value}
          onSelect={setAccent}
        />
      ))}
    </div>
  );
};

/* ─── Swatch ───────────────────────────────────────────────────── */

type SwatchProps = {
  option: AccentOption;
  active: boolean;
  onSelect: (value: AccentChoice) => void;
};

const Swatch = ({option, active, onSelect}: SwatchProps) => {
  const handleClick = () => onSelect(option.value);

  // CSS-переменная `--swatch-color` задаётся inline — цвет приходит из
  // конфига палитры, не из токенов; класс выразить нельзя.
  const style = {'--swatch-color': option.preview} as CSSProperties;

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-pressed={active}
      aria-label={option.label}
      className={clsx(styles.swatch, active && styles.swatchActive)}
      style={style}
    >
      <span className={styles.dot}>{active && <CheckOutlined className={styles.check} />}</span>
      <span className={styles.label}>{option.label}</span>
    </button>
  );
};
